import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import usePlaylist from 'sdk/hooks/usePlaylist'
import PostView from 'components/shared/PostView';
// import Button from 'components/shared/Button';
import ViewAll from 'components/shared/ViewAll';
import useFeedPosts from 'sdk/hooks/feed/useFeedPosts';
import styles from './Playlist.module.scss';
import ContentSection from '../ContentSection';
import PlaylistSkeleton from './PlaylistSkeleton';
import NoContent from '../NoContent/NoContent';
import { uniquePosts } from '../../../sdk/utils/uniquePosts';

function PlaylistMain({
  id,
  isDaily = false,
  count = 4,
  grid = false,
  title,
  userId,
  noHeader = false,
  activeCategoryId,
}: {
  id?: number,
  isDaily?: boolean,
  count?: number,
  grid?: boolean,
  title?: string,
  userId?: string,
  noHeader?: boolean,
  activeCategoryId?: string | undefined
}) {
  const playlistData = usePlaylist(id || '')
  const [loaded, setLoaded] = useState<boolean>(false);
  const [fetching, setFetching] = useState<boolean>(false);
  const [posts, setPosts] = useState<any>([]);
  const [activePostId, setActivePostId] = useState('')

  const feedData = useFeedPosts({ name: 'user_feed', id: userId || '' }, '', '', 100)

  useEffect(() => {
    if (feedData?.isFetched) {
      let postsData = feedData?.data?.pages.map((v) => v?.results).flat() || []

      if (activeCategoryId) {
        postsData = postsData.filter(
          (item) => item.data?.category?.id === +activeCategoryId,
        )
      }

      setPosts(uniquePosts(postsData))
      setLoaded(true)
    }
  }, [feedData.isFetched])

  useEffect(() => {
    setFetching(feedData.isFetching)
  }, [feedData.isFetching])

  const headerRight = posts?.length ? <ViewAll url={`/user/grid/user_feed/${userId}`} /> : null

  if (!posts.length && !isDaily && loaded) {
    return null
  }

  if (fetching || !loaded) {
    return (
      <PlaylistSkeleton
        grid={grid}
        count={count}
        title={title || playlistData?.data?.name}
        headerRight={headerRight}
        noHeader={noHeader}
      />
    )
  }

  return (
    <ContentSection
      title={title || playlistData?.data?.name}
      headerRight={headerRight}
      noHeader={noHeader}
    >
      <div className={clsx(
        styles.playlistPosts,
        grid && styles.playlistPostsGrid,
        count === 3 && styles.playlistPosts_3,
        feedData.isLoading && styles.playlistPosts_loading,
      )}
      >
        {posts.map((post: any, idx: number) => (
          <div
            className={clsx(
              styles.playlistItem,
              grid && styles.playlistItemGrid,
              (grid && idx === 0) && styles.playlistItemGridLarge,
            )}
            key={post?.id}
            onMouseEnter={() => setActivePostId(post?.id)}
            onMouseLeave={() => setActivePostId('')}
          >
            <PostView
              feedId={userId}
              feedName="user_feed"
              data={post}
              isDaily={isDaily}
              size={count}
              gridItemSize={(idx === 0) ? 'large' : 'small'}
              grid={(posts?.length > 3) && grid}
              isActive={post?.id === activePostId}
            />
          </div>
        ))}
      </div>
      {!posts.length && (
        <NoContent
          className={styles.noContent}
          message="No data satisfying the filters"
          small
        />
      )}
    </ContentSection>
  )
}

function PlaylistFollowing({
  id,
  isDaily = false,
  count = 4,
  grid = false,
  loading = false,
  title = '',
  userId,
  noHeader = false,
  activeCategoryId,
}: {
  id?: number,
  isDaily?: boolean,
  count?: number,
  grid?: boolean,
  loading?: boolean,
  title?:string
  userId?: string,
  noHeader?: boolean,
  activeCategoryId?: string | undefined
}) {
  if (loading) {
    return (
      <PlaylistSkeleton grid={grid} count={count} />
    )
  }

  return (
    <PlaylistMain
      id={id}
      isDaily={isDaily}
      count={count}
      grid={grid}
      title={title}
      userId={userId}
      noHeader={noHeader}
      activeCategoryId={activeCategoryId}
    />
  )
}

export default PlaylistFollowing
